module.exports = __webpack_public_path__ + "img/GooglePlayWhite.7b7e1272.svg";